import "./index.css";
import { useEffect, useState } from "react";
import Button from "../../Components/Core/Button";
import Text from "../../Components/Core/Text";
import Alert from "../../Components/Core/Alert";
import { Box } from "@mui/material";
import axios from "axios";
import Header from "../../Layout/Header";
import TextInput from "../../Components/Core/TextInput";
import Footer from "../../Layout/Footer";
import FAQCard from "../../Components/FAQCard";
import { FAQDATA, WhyUsData } from "../../Utils/dummyData";
import WhyUsCard from "../../Components/WhyUsCard";
import blob from "../../Assets/Images/blob.svg";
import blob2 from "../../Assets/Images/blob2.svg";
import blob3 from "../../Assets/Images/blob4.svg";
import blob4 from "../../Assets/Images/blob3.svg";
import blob5 from "../../Assets/Images/blob6.svg";
import successStories from "../../Assets/Images/s.jpg";
import { IoArrowForwardOutline, IoShieldCheckmarkSharp } from "react-icons/io5";
import { MdOutlineCall, MdOutlineCallMade } from "react-icons/md";
import { collection, addDoc } from "firebase/firestore";
import { db } from "../../Utils/db";
import * as Yup from "yup";
import moment from "moment";
import emailjs from "emailjs-com";

const scheduleSchema = Yup.object().shape({
  name: Yup.string()
    .required("Please enter your full name")
    .min(2, "Name must contain at least 2 characters")
    .max(50, "Name is too long (maximum 50 characters)")
    .matches(
      /^[a-zA-Z\s'-]+$/,
      "Please use only letters, spaces, hyphens, and apostrophes"
    )
    .test(
      "no-numbers",
      "Name cannot contain numbers",
      (value) => !/\d/.test(value || "")
    )
    .trim(),

  email: Yup.string()
    .required("Email address is required")
    .email("Please enter a valid email address")
    .matches(
      /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
      "Please enter a valid email address"
    )
    .max(100, "Email address is too long")
    .lowercase()
    .trim(),

  company: Yup.string()
    .required("Please enter your company or organization name")
    .min(2, "Company name must be at least 2 characters")
    .max(100, "Company name is too long (maximum 100 characters)")
    .trim(),

  time: Yup.date()
    .transform((value, originalValue) => (originalValue === "" ? null : value))
    .required("Please select your preferred consultation time")
    .min(
      new Date(Date.now() + 60 * 60 * 1000),
      "Please select a time at least 1 hour from now"
    )
    .test(
      "business-hours",
      "Selected time must be during business hours: Weekdays 10AM–5PM, Saturday 9AM–5PM (Closed on Sunday)",
      function (value) {
        if (!value) return false;

        const date = new Date(value);
        const day = date.getDay(); // 0 = Sunday, 6 = Saturday
        const hour = date.getHours();

        if (day === 0) return false; // Sunday Closed

        if (day === 6) {
          // Saturday: 9 AM – 5 PM
          return hour >= 9 && hour < 17;
        }

        // Weekdays: 10 AM – 5 PM
        return hour >= 10 && hour < 17;
      }
    ),

  message: Yup.string()
    .required("Please describe your project or consultation needs")
    .min(30, "Please provide more detailed information (minimum 30 characters)")
    .max(1000, "Message is too long (maximum 1000 characters)")
    .test(
      "quality-content",
      "Please provide specific details about your project needs",
      function (value) {
        if (!value) return false;

        const trimmed = value.trim().toLowerCase();
        const words = trimmed.split(/\s+/);
        const uniqueWords = new Set(words);

        return (
          uniqueWords.size >= 8 &&
          !trimmed.includes("test") &&
          !trimmed.includes("testing")
        );
      }
    )
    .trim(),
});

const Index = () => {
  const [isAlert, setisAlert] = useState<any>({
    type: "",
    message: "",
  });
  const [data, setdata] = useState<any>({
    email: "",
    name: "",
    company: "",
    time: "",
    message: "",
  });
  const [isLoading, setisLoading] = useState(false);
  const [currentTag, setcurrentTag] = useState("Web Development");
  const [infos, setinfos] = useState({} as any);

  const TAGS = [
    "Web Development",
    "App Development",
    "Database Management",
    "Emerging Technologies",
    "Cloud Computing",
    "DevOps",
    "UI/UX Design",
    "Cybersecurity",
    "AI & Machine Learning",
    "Data Analytics",
    "IoT Solutions",
    "AR/VR Development",
    "SaaS Development",
    "E-commerce Solutions",
    "Custom Software Development",
    "QA & Testing",
    "API Integration",
    "IT Consulting",
    "Automation & RPA",
  ];

  useEffect(() => {
    const findMyIp = async () => {
      const res = await axios.get("http://ip-api.com/json/");
      return res.data;
    };

    findMyIp()
      .then((res) => {
        setinfos(res);
      })
      .catch((err) => {
        console.log("Error getting account info: ");
      });
  }, []);

  useEffect(() => {
    let index = 0;

    const interval = setInterval(() => {
      setcurrentTag(TAGS[index]);
      index = (index + 1) % TAGS.length;
    }, 5000);

    return () => clearInterval(interval);
  }, []);

  const handleSchedule = async () => {
    try {
      await scheduleSchema.validate(data, { abortEarly: false });
      setisLoading(true);

      const locationData = {
        userAgent: navigator.userAgent,
        platform: navigator.platform,
        language: navigator.language,
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        referrer: document.referrer || "",
      };

      const docRef = await addDoc(collection(db, "scheduledCalls"), {
        ...data,
        createdAt: moment().format("YYYY-MM-DD HH:mm:ss"),
        isActive: true,
        review: "",
        mode: "",
        services: "",
        metadata: { ...locationData, ...infos },
        statusLog: [
          {
            status: "scheduled",
            timestamp: moment().format("YYYY-MM-DD HH:mm:ss"),
          },
        ],
      });

      if (docRef) {
        await emailjs.send(
          "service_9b22mz4",
          "template_oli1exl",
          {
            name: data.name,
            email: data.email,
            message: data.message,
            time: data.time,
            company: data.company,
          },
          "KvnBSuKIx5X_2K0aY"
        );

        setdata({
          email: "",
          name: "",
          company: "",
          time: "",
          message: "",
        } as any);

        setisAlert({
          type: "success",
          message:
            "Your call has been scheduled. We will contact you soon. Thank you!",
        });
      } else {
        setisAlert({
          type: "error",
          message: "Error scheduling call",
        });
      }
    } catch (error: any) {
      setisLoading(false);

      if (error instanceof Yup.ValidationError) {
        setisAlert({
          type: "error",
          message: error.errors[0],
        });
      } else {
        setisAlert({
          type: "error",
          message: "Unexpected error while scheduling call",
        });
      }
    } finally {
      setisLoading(false);
    }
  };

  const scrollToClass = (className: string) => {
    const element = document.getElementsByClassName(className)[0];
    element.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <Box className="landing">
      <Header
        onHomeClick={() => scrollToClass("col1")}
        onClickFreeConsultation={() => scrollToClass("col1BodyDetails")}
        onServicesClick={() => scrollToClass("landingServices")}
        onWhyUsClick={() => scrollToClass("landingWhy")}
        onFaqClick={() => scrollToClass("landingFaq")}
        onAboutClick={() => scrollToClass("knowMore")}
      />
      <Box className="col1">
        <Box className="col1Body" />
      </Box>
      <Box className="col1BodyDetails">
        <Box
          sx={{ color: "#f2ff58" }}
          className="tag animate__animated animate__fadeInUp"
        >
          {currentTag}
        </Box>
        <Text type="h1" className="headerMainTitle">
          Your Growth Partner in Digital Transformation
        </Text>
        <Text
          type="p"
          style={{
            fontSize: 14.5,
            color: "#fff",
            fontWeight: "normal",
            marginTop: "1em",
            opacity: 0.7,
            lineHeight: 1.6,
          }}
        >
          We help businesses grow through practical IT consulting and software
          development. We focus on understanding your specific needs, then build
          technology solutions that save you time and money while opening up new
          opportunities for your business
        </Text>

        <Button
          color="secondary"
          style={{
            marginTop: "2em",
            height: "56px",
            backgroundColor: "white",
            color: "#002741",
            fontWeight: "bold",
            borderRadius: 24,
          }}
          onClick={() => scrollToClass("landingServices")}
        >
          Explore Services
        </Button>
      </Box>
      <Box className="col1BodyConsultaion">
        <Text
          type="h1"
          style={{ fontSize: 36, color: "#002741", fontWeight: "bold" }}
        >
          Book Free Consultation
        </Text>
        <Text
          type="p"
          style={{
            fontSize: 14.5,
            color: "#002741",
            fontWeight: "normal",
            marginTop: "1em",
            opacity: 0.7,
          }}
        >
          Fill out the form below, and we'll arrange a 45 mins free consultation
          at a time most suitable for you. (EST Timezone)
        </Text>
        <Box
          style={{
            display: "flex",
            flexDirection: "row",
            margin: "1em 0",
          }}
        >
          <TextInput
            value={data.name}
            onChange={(e) => setdata({ ...data, name: e.target.value })}
            type="text"
            placeholder="Enter Your Name *"
            style={{ width: "48%", marginRight: "auto" }}
          />
          <TextInput
            value={data.email}
            onChange={(e) => setdata({ ...data, email: e.target.value })}
            type="text"
            placeholder="Enter Your Email *"
            style={{ width: "48%", marginLeft: "auto" }}
          />
        </Box>

        <Box
          style={{
            display: "flex",
            flexDirection: "row",
          }}
        >
          <TextInput
            value={data.company}
            onChange={(e) => setdata({ ...data, company: e.target.value })}
            type="text"
            placeholder="Enter Your Company *"
            style={{ width: "48%", marginRight: "auto" }}
          />

          <TextInput
            value={data.time}
            onChange={(e) => setdata({ ...data, time: e.target.value })}
            type="datetime-local"
            placeholder="Enter Your Time *"
            style={{
              marginLeft: "auto",
              width: "48%",
              opacity: !data.time ? 0.5 : 1,
            }}
          />
        </Box>
        <TextInput
          value={data.message}
          onChange={(e) => setdata({ ...data, message: e.target.value })}
          type="text"
          placeholder="Enter Your Message *"
          style={{ width: "100%", marginTop: "1em" }}
          multiline
        />

        <Button
          style={{
            marginTop: "1em",
            height: "56px",
          }}
          color="secondary"
          onClick={handleSchedule}
          isLoading={isLoading}
        >
          Submit Request
        </Button>
      </Box>
      <Box className="landingWhy animate__animated animate__fadeInUpBig">
        <Text className="landingHeading">Why Us?</Text>
        <Text type="p" className="landingTagline">
          We build IT solutions that fit your specific business needs. Our
          experienced team uses proven technology to solve real problems, and we
          stick around to help you succeed long-term.
        </Text>
        <Box className="whyUs">
          {WhyUsData.map((item: any, index: any) => (
            <WhyUsCard
              key={index}
              index={index}
              title={item.type}
              description={item.description}
              category={item.category}
            />
          ))}
        </Box>
      </Box>

      <Box className="landingSuccess animate__animated animate__fadeInUpBig">
        <Box className="landingSuccess_head">
          <Box className="landingSuccess_head_left">
            <img src={successStories} alt="successStories" />
          </Box>
          <Box className="landingSuccess_head_right">
            <Box className="tag" sx={{ color: "#f2ff58" }}>
              Client Stories
            </Box>
            <Text className="landingHeading">
              Hear success stories from our satisfied users
            </Text>
            <Box sx={{ mt: "auto" }}>
              <Text
                type="p"
                style={{ textAlign: "left" }}
                className="landingTagline"
              >
                Hear from our clients about their experience with us and how we
                helped them achieve their goals. We are proud to be a part of
                their success
              </Text>
              <Button
                style={{
                  backgroundColor: "white",
                  color: "#002741",
                  fontSize: 15,
                  height: 50,
                  padding: "0 20px",
                  marginTop: "2em",
                  width: "fit-content",
                }}
                onClick={() => {
                  scrollToClass("col1");
                  setisAlert({
                    type: "warning",
                    message:
                      "Schedule a call to discuss your project and see examples of our work",
                  });
                }}
              >
                View All Stories
                <IoArrowForwardOutline
                  size={20}
                  style={{
                    marginLeft: "8px",
                  }}
                />
              </Button>
            </Box>
          </Box>
        </Box>
      </Box>
      <Box className="landingServices ">
        <Text className="landingHeading">Services</Text>
        <Text type="p" className="landingTagline">
          Our IT services help businesses work more efficiently. We build custom
          software, improve systems, and provide ongoing support to help you
          focus on what you do best while technology handles the rest.
        </Text>
        <Box className="services  animate__animated animate__fadeInUpBig">
          <Box className="serviceCardTop">
            <img src={blob} className="blobImage1" />
            <Box className="serviceCardTopContent">
              <Text type="h3" className="serviceCardTopContentHeading">
                Web Development
              </Text>
              <Text type="p" className="serviceCardTopContentDescription">
                We build websites that work well on all devices and are easy for
                your customers to use. Whether you need a simple business site
                or a complex web application, we create solutions that help your
                business grow online.
              </Text>
            </Box>
          </Box>

          <Box className="serviceCardTop">
            <img src={blob2} className="blobImage2" />
            <Box className="serviceCardTopContent">
              <Text type="h3" className="serviceCardTopContentHeading">
                App Development
              </Text>
              <Text type="p" className="serviceCardTopContentDescription">
                Custom mobile apps for iPhone and Android that people enjoy
                using. Whether you need a simple app or advanced business
                software, our process covers everything from concept development
                to final launch in the app stores
              </Text>
            </Box>
          </Box>

          <Box className="serviceCardTop">
            <img src={blob3} className="blobImage3" />
            <Box className="serviceCardTopContent">
              <Text type="h3" className="serviceCardTopContentHeading">
                Database Management
              </Text>
              <Text type="p" className="serviceCardTopContentDescription">
                Data organization and security solutions that help you find
                information quickly. Professional database management ensures
                your business data stays safe, backed up, and available when you
                need it most.
              </Text>
            </Box>
          </Box>

          <Box className="serviceCardTop" sx={{ width: "63%" }}>
            <img src={blob5} className="blobImage4" loading="lazy" />
            <Box className="serviceCardTopContent">
              <Text type="h3" className="serviceCardTopContentHeading">
                Modern Technology Solutions
              </Text>
              <Text type="p" className="serviceCardTopContentDescription">
                Modern technology solutions including AI, automation, and cloud
                services tackle specific business challenges. Rather than
                adopting technology just because it's new, the approach focuses
                on tools that genuinely improve operations and customer service
              </Text>
            </Box>
          </Box>

          <Box className="serviceCardTop">
            <img src={blob4} className="blobImage5" />
            <Box className="serviceCardTopContent">
              <Text type="h6" className="serviceCardTopContentHeading">
                Not sure what you need?
              </Text>
              <Text type="p" className="serviceCardTopContentDescription">
                We offer a free consultation to understand your business
                challenges and recommend the right technology solutions.
                Schedule a call with us and let's figure out how we can help.
              </Text>

              <Button
                color="secondary"
                style={{
                  marginTop: "1em",
                  borderRadius: 24,
                }}
                onClick={() => scrollToClass("col1BodyDetails")}
              >
                Book Free Consultation
              </Button>
            </Box>
          </Box>
        </Box>
      </Box>
      <Box className="knowMore">
        <Text className="knowMoreHeading">The People Behind Your Projects</Text>

        <Text type="p" className="landingTagline">
          Skilled developers and consultants who listen to your challenges
          first, then build solutions that address them. Your success is
          measured by how well the technology works for your business.
        </Text>
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            flexWrap: "wrap",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          {[
            "Dedicated Project Managers",
            "Experienced Developers",
            "Creative Designers",
            "Quality Assurance Experts",
            "Customer Support Team",
          ].map((item, index) => (
            <Box key={index} className="knowMoreCard">
              <IoShieldCheckmarkSharp color="#2dd06b" />
              <Text type="h6" className="knowMoreCardHeading">
                {item}
              </Text>
            </Box>
          ))}
        </Box>
        <Button color="secondary" className="hireTeamButton">
          Hire Team
        </Button>
      </Box>
      <Box className="landingFaq">
        <Text className="landingHeading">FAQs</Text>

        <Text type="p" className="landingTagline">
          Questions about working with us? Here are answers to what most clients
          want to know about our development process, pricing, and services.
        </Text>
        {FAQDATA.map((item: any, index: any) => (
          <FAQCard
            question={item.question}
            key={index}
            answer={item.answer}
            isOpen={index === 0}
          />
        ))}
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            margin: "1.6em 0",
          }}
        >
          {/* <Box
            className="knowMoreCard"
            onClick={() => window.open("tel:+1(443)584-3062", "_blank ")}
            sx={{ cursor: "pointer" }}
          >
            <img src={usa} width={20} height={20} alt="usa" />
            <Text type="h6" className="knowMoreCardHeading">
              Call Us
            </Text>
          </Box> */}

          <Box
            className="knowMoreCard"
            onClick={() => window.open("tel:+918809660774", "_blank ")}
            sx={{ cursor: "pointer" }}
          >
            <MdOutlineCall color="#2dd06b" size={19} />
            <Text type="h6" className="knowMoreCardHeading">
              Call Us
            </Text>
          </Box>

          <Box
            className="knowMoreCard"
            onClick={() => window.open("mailto:contact@insyt.work", "_blank ")}
            sx={{ cursor: "pointer" }}
          >
            <MdOutlineCallMade color="#2dd06b" size={20} />
            <Text type="h6" className="knowMoreCardHeading">
              Contact@insyt.work
            </Text>
          </Box>
        </Box>
      </Box>

      <Footer
        onClickFreeConsultation={() => scrollToClass("col1BodyDetails")}
        onClickExploreServices={() => scrollToClass("landingServices")}
        onServicesClick={() => scrollToClass("landingServices")}
        onWhyUsClick={() => scrollToClass("landingWhy")}
        onFaqClick={() => scrollToClass("landingFaq")}
        onAboutClick={() => scrollToClass("knowMore")}
      />

      <Alert
        open={isAlert.type !== ""}
        handleClose={() => setisAlert({ type: "", message: "" })}
        type={isAlert.type}
        message={isAlert.message}
      />
    </Box>
  );
};

export default Index;
